// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3r8CR","name":"Header_name__29Bpw","birthday":"Header_birthday__3vZOz","skeleton":"Header_skeleton__uIkW6"};